/** A Material Symbols glyph (the self-hosted font, DESIGN.md §4). Decorative: the word next to it carries the meaning. */
export function Icon({ name, size = 20, className }: { name: string; size?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`material-symbols-outlined select-none leading-none ${className ?? ""}`}
      style={{ fontSize: size }}
    >
      {name}
    </span>
  );
}
